module.exports = __webpack_public_path__ + "img/kwispelcoach.83003468.svg";